import { action } from '@play-co/replicant';
import createActions from '../../config/actions/createActions';
import {
  magicLampsPlay,
  magicLampsPlayRound,
  magicLampsContinue,
  magicLampsCollectRewards,
  magicLampsView,
} from './magiclamps.modifiers';
import { magicLampsIsCompleted } from './magiclamps.getters';

export const match2MagicLampsActions = createActions({
  /**
   * View magic lamps popup and record the timestamp.
   */
  magicLampsView: action((state, _: void, api) => {
    return magicLampsView(state, api.date.now());
  }),

  /**
   * Attempt to start playing magic lamps gameplay and return true if successful,
   * or false if not enough gems.
   */
  magicLampsPlay: action((state, _: void, api) => {
    // Attempt to play magic lamps
    const result = magicLampsPlay(state, api);

    return result;
  }),

  /**
   * Play a round of magic lamps and return the round results.
   */
  magicLampsPlayRound: action((state, _: void, api) => {
    return magicLampsPlayRound(state, api.date.now());
  }),

  /**
   * Attempt to continue playing magic lamps gameplay and return true if successful,
   * or false if not enough gems.
   */
  magicLampsContinue: action((state, _: void, api) => {
    // Attempt to continue magic lamps
    const result = magicLampsContinue(state, api);

    return result;
  }),

  /**
   * Collect the rewards from magic lamps gameplay and return true if successful,
   * or false if user cannot collect rewards.
   */
  magicLampsCollectRewards: action((state, _: void, api) => {
    const now = api.date.now();

    // Check if user has completed the magic lamps event
    const isCompleted = magicLampsIsCompleted(state);

    // Sub feature for the currency grant event
    const subFeature = isCompleted ? 'complete' : 'exit';

    // Collect the rewards
    const result = magicLampsCollectRewards(state, subFeature, api);

    return result;
  }),
});
